import AddIcon from '@atlaskit/icon/core/add';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import OpenIcon from '@atlaskit/icon/core/arrow-up-right';
import CopyIcon from '@atlaskit/icon/core/copy';
import ActivityIcon from '@atlaskit/icon/core/dashboard';
import EditIcon from '@atlaskit/icon/core/edit';
import DocumentIcon from '@atlaskit/icon/core/file';
import FolderIcon from '@atlaskit/icon/core/folder-closed';
import NotificationDirectIcon from '@atlaskit/icon/core/notification';
import PageIcon from '@atlaskit/icon/core/page';
import UserAvatarCircleIcon from '@atlaskit/icon/core/person-avatar';
import SettingsIcon from '@atlaskit/icon/core/settings';
import UndoIcon from '@atlaskit/icon/core/undo';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FORGE_COMMAND_PALETTE_ICON_MAP: Record<string, React.FC<any> | undefined> = {
	add: AddIcon,
	'arrow-right': ArrowRightIcon,
	copy: CopyIcon,
	open: OpenIcon,
	page: PageIcon,
	edit: EditIcon,
	'user-avatar': UserAvatarCircleIcon,
	activity: ActivityIcon,
	settings: SettingsIcon,
	undo: UndoIcon,
	document: DocumentIcon,
	'notification-direct': NotificationDirectIcon,
	folder: FolderIcon,
};
